import LocationOn from '@ixigo/icons/LocationOnFilled';
import * as Timeline from '@ixigo/iui/Timeline';
import Typography from '@ixigo/iui/Typography';
import { Skeleton } from '@repo/shared/components';
import type { TransformedBookingInfo } from './utils';

interface RouteInfoProps {
	loading: boolean;
	rideDetails?: TransformedBookingInfo['rideDetails'];
}

export const RouteInfo = ({ rideDetails, loading }: RouteInfoProps) => {
	const { pickup, drop } = rideDetails || {};
	const timelineItems = [pickup, drop];
	return (
		<div className="ride-details flex flex-col gap-2.5">
			<Timeline.Root
				orientation="vertical"
				contentPosition="end"
				className="w-full overflow-hidden"
			>
				{timelineItems.map((item, index) => (
					<Timeline.Item key={index} className="relative">
						<Timeline.Separator
							indicator={
								<LocationOn className="size-20 shrink-0 text-secondary" />
							}
							connector={
								<div
									className={`w-px h-full border-x border-secondary ${
										index === timelineItems.length - 1 ? 'hidden' : ''
									}`}
								/>
							}
						/>
						<Timeline.Content className="overflow-hidden">
							<Skeleton
								loading={loading}
								level="body-sm"
								height={16}
								variant="circular"
							>
								<Typography
									variant="body-sm"
									className="overflow-hidden text-ellipsis truncate relative text-secondary"
								>
									{item?.location || ''}
								</Typography>
							</Skeleton>
						</Timeline.Content>
					</Timeline.Item>
				))}
			</Timeline.Root>
		</div>
	);
};
